'use strict';

var React = require('react');

var SvgLayoutColumns2Icon = function SvgLayoutColumns2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 3c-2.071 0-3.75 1.679-3.75 3.75v6.5c0 2.071 1.679 3.75 3.75 3.75h6.5c2.071 0 3.75-1.679 3.75-3.75v-6.5c0-2.071-1.679-3.75-3.75-3.75h-6.5Zm-2.25 3.75c0-1.243 1.007-2.25 2.25-2.25h2.5v11h-2.5c-1.243 0-2.25-1.007-2.25-2.25v-6.5Zm6.25 8.75h2.5c1.243 0 2.25-1.007 2.25-2.25v-6.5c0-1.243-1.007-2.25-2.25-2.25h-2.5v11Z"
  }));
};
SvgLayoutColumns2Icon.displayName = "LayoutColumns2Icon";

exports.SvgLayoutColumns2Icon = SvgLayoutColumns2Icon;
